"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStringLength = void 0;
const getStringLength = (str) => {
    // taken from https://stackoverflow.com/a/54369605/4672339
    return Array.from(str).length;
};
exports.getStringLength = getStringLength;
//# sourceMappingURL=get_string_length.js.map